import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0035',
    ecrans: ['00-2'],
    params: ['?vaedaptypapr']
});
